import { render, staticRenderFns } from "./WorldObjectIcon.vue?vue&type=template&id=c95f2c1c&scoped=true&"
import script from "./WorldObjectIcon.vue?vue&type=script&lang=js&"
export * from "./WorldObjectIcon.vue?vue&type=script&lang=js&"
import style0 from "./WorldObjectIcon.vue?vue&type=style&index=0&id=c95f2c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../food/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95f2c1c",
  null
  
)

export default component.exports